import Youth from "../img/youthdiaries.png";

const PortfolioData = [
  {
    id: 1,
    alt: "Mobile Legend Pics",
    link: "https://chipuifirstproject.netlify.app/",
    image: "https://chipuifirstproject.netlify.app/hero/wall.jpg",
    title: "My First Project (HTML, CSS, BootStrap)",
  },
  {
    id: 2,
    alt: "Chipui Kasar Pictures",
    link: "https://kasar.netlify.app/",
    image: "https://kasar.netlify.app/static/media/myPic.e44d9288.jpg",
    title: "My First portfolio (ReactJs)",
  },
  {
    id: 3,
    alt: "Khangkhui Khunou, Khangkhui Phungdhar",
    link: "https://khangkhuikhunou.netlify.app/",
    image:
      "https://firebasestorage.googleapis.com/v0/b/khangkhuiphungdhar.appspot.com/o/file%2FKHANGKHUI%20PHUNGDHAR.jpg%20on%2004-Jan-2024%2C%2021%3A03%3A18?alt=media&token=a0339607-eba5-4911-99f9-24a39479e3db",
    title: "Khangkhui Khunou (HTML, CSS, BootStrap)",
  },
  {
    id: 4,
    alt: "Khangkhui Khunou, Khangkhui Phungdhar",
    link: "https://khangkhuiPhungdhar.vercel.app/",
    image:
      "https://firebasestorage.googleapis.com/v0/b/khangkhuiphungdhar.appspot.com/o/file%2FKHANGKHUI%20PHUNGDHAR.jpg%20on%2004-Jan-2024%2C%2021%3A03%3A18?alt=media&token=a0339607-eba5-4911-99f9-24a39479e3db",
    title: "Khangkhui Khunou (ReactJS)",
  },
  {
    id: 5,
    alt: "NIELIT O-LEVEL Questions",
    link: "https://nietlitolevelquestions.netlify.app/",
    image: "https://pksmbd.co.in/img/images/olevel.jpg",
    title: "NIELIT O-Level Questions",
  },
  {
    id: 6,
    alt: "Tengkuma Blog Page",
    link: "https://tengkuma.vercel.app/",
    image: "https://media.graphassets.com/RuUFzf4SSZYGVsiskbQf",
    title: "Tengkuma Blog Page",
  },
  {
    id: 7,
    alt: "Tangkhul Song Lyrics",
    link: "https://tangkhullyrics.com/",
    image:
      "data:image/x-icon;base64,AAABAAEALi4AAAAAIACLAQAAFgAAAIlQTkcNChoKAAAADUlIRFIAAAAuAAAALggGAAAAV7krNwAAAUBJREFUeJzsmcENwyAMRRmECTpBFmGQTsAEXaRL5JYJMkEXSbGEJYTcKA3GxhJf+oeoSfpq2cZQ5/ronXwQXpNDp+/sCo7+JD/V6BrAyx8QLIKj4X6vQtoIDt5VSBnAMfImwcFRgZcF/NDsOK3gh1axcoCr5DsHuErUa/BasOhs1T2UXxKw/4Cjlty/z+CHBEfFE/AwMjj1jEq63AGnnsNBbHjwX2kTLIC7vHKq9PRWcEd0GzPgS/UOuDYB7nJHEc1zLnCXu4pYW+QEXyQLlBMcW6RJcJeHMpPgIprgM+IzVRQES29pP3Jxxgt7w1jME+rg5ZBz1RuxgxeTL4YbDovowQwtBr4yQ4uA17sOM+B3inGCtyh0iLbYgQ43uNiZCGfUd+kzbg74La8J4vIXD98pD/F3N/R23GWfFSB8Lgb8BQAA//8YA2GNAAAABklEQVQDAFePIGGl4HWkAAAAAElFTkSuQmCC",
    title: "Tangkhul Song Lyrics",
  },
  {
    id: 8,
    alt: "Tangkhul English Dictionary",
    link: "https://tangkhuldictionary.lovable.app/",
    image:
      "https://pub-bb2e103a32db4e198524a2e9ed8f35b4.r2.dev/9933d88e-8930-40bf-a212-a038aedae903/id-preview-68ff0481--d944e536-c49d-410b-bddd-58ea2ba6edac.lovable.app-1763002510575.png",
    title: "Tangkhul English Dictionary",
  },
  {
    id: 9,
    alt: "The Youth Diaries | Adventure",
    link: "https://mrdoob.com/projects/chromeexperiments/google-gravity/",
    image: Youth,
    title: "The Youth Diares (Ongoing)",
  },
];

export default PortfolioData;
